export default "__VITE_ASSET__cyKRxPq___"